import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { Section } from './ui/Section';
const faqs = [{
  question: '¿Funciona si tengo niños y mascotas?',
  answer: "¡Absolutamente! El método está diseñado específicamente para 'casas vivas'. No buscamos una casa de revista estática, sino un hogar higiénico y ordenado que convive con el caos normal de la familia."
}, {
  question: '¿Es seguro para mi familia?',
  answer: 'Sí. Los 2 ingredientes son 100% seguros, no tóxicos y libres de químicos agresivos. Son seguros para bebés, mascotas y personas con alergias.'
}, {
  question: '¿Necesito comprar productos costosos?',
  answer: 'No. De hecho, ahorrarás dinero. Los 2 ingredientes son extremadamente económicos y fáciles de conseguir en cualquier supermercado o farmacia.'
}, {
  question: '¿Es realmente solo 15 minutos al día?',
  answer: "Sí. Una vez que implementas la 'base' (que toma un fin de semana), el mantenimiento diario está cronometrado para tomar exactamente 15 minutos gracias a la potencia de la mezcla limpiadora."
}, {
  question: '¿Es una suscripción mensual?',
  answer: 'No. Es un pago único de $12.97. Tienes acceso de por vida al ebook y a todas las actualizaciones futuras.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section background="white" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <HelpCircle className="w-10 h-10 text-[#2C7A7B] mx-auto mb-4" data-id="element-52" />
          <h2 className="text-3xl font-serif font-bold text-gray-900" data-id="element-53">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-56">
                <span className="font-bold text-gray-800" data-id="element-57">{faq.question}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-58" />
              </button>

              <AnimatePresence data-id="element-59">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-60">
                    <div className="p-5 pt-0 text-gray-600 leading-relaxed bg-white border-t border-gray-100" data-id="element-61">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}